import "core-js";
import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";
import "babel-polyfill";
import "isomorphic-fetch";

import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import "bootstrap/dist/css/bootstrap.css";
import "antd/dist/antd.css";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import { createStore, applyMiddleware } from "redux";
import { Provider } from "react-redux";
import { composeWithDevTools } from "redux-devtools-extension";
import rootReducer from "./store/reducers";
import thunk from "redux-thunk";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage"; // defaults to localStorage for web
import { PersistGate } from "redux-persist/integration/react";
import { ConfigProvider } from "antd";
import moment from "moment";
import locale from "antd/es/locale/hr_HR";
import "moment/locale/hr";
moment.locale("hr");

const persistConfig = {
  key: "root",
  storage,
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

let middleware = applyMiddleware(thunk);
if (process.env.NODE_ENV == "development") {
  middleware = composeWithDevTools(applyMiddleware(thunk));
}

export const store = createStore(persistedReducer, middleware);

let persistor = persistStore(store);

ReactDOM.render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <ConfigProvider locale={locale}>
        <App />
      </ConfigProvider>
    </PersistGate>
  </Provider>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
